<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="noindent_t_1"><b><i>Fall in love with this fan-favorite novella of family, romance and dogs from author Valerie Hansen.</i></b></p>
<p class="noindent_t1">Single mom Krista Brody has no problem walking up to a neighbour’s door while searching for her son’s runaway puppy, Puddles. But the stranger who opens the door is very familiar…</p>
<p class="noindent_t1">Mark Vanbruger hasn’t seen Krista in years, but now they’re living in the same small town. They missed a chance at romance years ago—could a matchmaking puppy help them find happiness as a family now?</p>
<p class="noindent_t1"><i>Originally published in 2003.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369700407_BCC.vue?ee59b3fe